import * as Routes from 'common/js-route.js.erb'
export default Routes
